import { render, staticRenderFns } from "./GoodGroup.vue?vue&type=template&id=74180eee&scoped=true&"
import script from "./GoodGroup.vue?vue&type=script&lang=js&"
export * from "./GoodGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74180eee",
  null
  
)

export default component.exports